import { Organization } from "../../organization/organization-api"
import { PersonType } from "./person-type.enum"

export interface Plan {
    id: number
    name: string
    description: string
    price: number
    isCustom: boolean
    customPrice?: number | null
    private: boolean
    recurrence: string
    features: Record<string, unknown>
    modules?: string[]
    createdAt: string
    updatedAt: string
    deleted: boolean
}

export interface SubscriptionPayment {
    id: number
    subscriptionId: number
    companyId: number
    creditCardNumber?: string | null
    creditCardBrand?: string | null
    dateRef: string
    amount: number
    status?: string | null
    paymentId: string
    createdAt: string
    updatedAt: string
    deleted: boolean
}

export interface Subscription {
    id: number
    planId: number
    plan: Plan
    authorizeRecurringPayment: boolean
    gatewayCustomerId?: string | null
    gatewayCardToken?: string | null
    lastPaymentId?: number | null
    lastPayment?: SubscriptionPayment | null
    lastPaymentDate?: string | null
    // Fim do período grátis concedido pelo link de cadastro (null = sem cortesia)
    trialEndsAt?: string | null
    dueDay: number
    status: string
    companyId: number
    createdAt: string
    updatedAt: string
    deleted: boolean
}

export enum CompanySegment {
    HEALTH = 'HEALTH',
    BEAUTY = 'BEAUTY',
    FITNESS = 'FITNESS',
    PET_SHOP = 'PET_SHOP',
    DIRECT_SALE = 'DIRECT_SALE',
    QUOTE_BASED_SALE = 'QUOTE_BASED_SALE',
    OTHER = 'OTHER',
}

export enum CompanySecondarySegment {
    INTERMEDIATION = 'INTERMEDIATION',
    OTHER = 'OTHER',
}

export interface Company {
    id: number
    name: string
    tradingName: string
    /** Natureza jurídica da conta. PF não tem CNPJ, filial nem emissão de nota. */
    personType: PersonType
    cnpj: string
    cpf: string
    stateRegistration: string
    municipalRegistration: string
    email: string
    phone: string
    website: string
    logoUrl?: string
    aboutUs: string
    active: boolean
    createdAt: string
    updatedAt: string
    street: string
    number: string
    complement: string
    neighborhood: string
    city: string
    state: string
    zipCode: string
    country: string
    taxRegime: string
    cnae: string
    economicActivity: string
    bankCode: string
    bankAgency: string
    bankAccount: string
    pixKey: string
    pixKeyType: string
    whatsappNumber: string
    segment?: CompanySegment
    secondarySegment?: CompanySecondarySegment
    organizationId?: number
    subscription?: Subscription | null
    organization?: Organization | null
}
